import React from "react";
import { Show, SimpleShowLayout, TextField, RichTextField, DateField, BooleanField, SelectField } from "react-admin";

import { dateOptions, languageChoices, newsChoices } from "../../../utils/options";
import CustomImage from "../Partials/CustomComponents/CustomImage";

const ShowNews = () => {
  return (
    <Show title="Детайли за новина">
      <SimpleShowLayout>
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <TextField
          label="Заглавие"
          source="title"
        />
        <SelectField
          label="Тип"
          source="news_type"
          choices={newsChoices}
        />
        <TextField
          label="Подзаглавие"
          source="sub_head"
        />
        <DateField
          label="Начална дата"
          source="starting_on"
          locales={"bg"}
          options={dateOptions}
        />
        <DateField
          label="До дата"
          source="ending_on"
          locales={"bg"}
          options={dateOptions}
        />
        <DateField
          label="Дата на публикуване"
          source="date_beginning"
          locales={"bg"}
          options={dateOptions}
        />
        <DateField
          label="Дата на последна редакция"
          source="last_modified"
          locales={"bg"}
          options={dateOptions}
        />
        <TextField
          label="Кратко описание"
          source="short_description"
        />
        <TextField
          label="Ключови думи"
          source="tags"
        />
        <RichTextField
          label="Съдържание"
          source="content"
        />
        <CustomImage
          style={{
            maxHeight: "10rem",
            maxWidth: "100%",
            marginBottom: "2rem",
          }}
        />
        <BooleanField
          label="Скрита"
          source="is_hidden"
        />
      </SimpleShowLayout>
    </Show>
  );
};
export default ShowNews;
